import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/showsofindia.png"

export function Index() {
  return (
    <Layout
      title="Shows of India Live Entertainment Revival Success with Premagic AI Photos"
      description="EVA Live rekindled live entertainment at Shows of India using Premagic’s AI photo platform to boost audience engagement and event impact."
      metaImage={ThumbnailImage}
      keywords={[
        "Shows of India case study, live entertainment events, EVA Live partnership, entertainment industry photos, live show technology, entertainment event management, audience engagement entertainment, live performance photos, entertainment networking events, show business technology, live event solutions, entertainment industry networking, performance event photos, entertainment marketing platform, live show engagement",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Shows of India", url: "/case-study/showsofindia/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Shows of India Live Entertainment Revival Success with Premagic AI Photos",
            "description": "EVA Live rekindled live entertainment at Shows of India using Premagic’s AI photo platform to boost audience engagement and event impact.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.SHOWSOFINDIA} />
    </Layout>
  )
}

export default Index
